<h1 class="sr-only"><span>GALERÍA SORTEO ANÁHUAC MAGNO 2026</span></h1>

<section class="stc-galeria banner-padding ">
    <div class="container">
        <div class="row sub-headers-inside">

            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">Galería de </span></span>
                    <h2 class="main-text">ganadores</h2>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="info-ganadores">
    <div class="container">
        <div class="row">

            <div class="col-md-8 offset-md-2 text-center my-auto">
                <div class="overlap-signature header-inside">
                    <h2 class="main-text">Conoce a nuestros</h2>
                    <span class="letter"> <span class="signature-text" style="color: #62237b !important;">afortunados ganadores</span></span>
                </div>

                <p class="mt-5">
                    de nuestra <strong>Décima Edición</strong>, miles de emociones, <strong>miles</strong> de sonrisas y <strong>cientos</strong> de premios entregados.
                </p>

                <a href="https://www.youtube.com/@sorteoanahuac_oficial" target="_blank" class="mt-3">Conoce a nuestros ganadores en video

                </a>
            </div>

            

        </div>
    </div>
</section>


<section class="stc-premios">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center p-0">


        <div class="custom-slider-container">
          <ngb-carousel #carousel1 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c1-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premios/premio1.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">EDO. MÉXICO</h1>
                    <h3 class="subtitle-place">Blue Bosque Real</h3>
                    <p class="description">Departamento Amueblado</p>
                    <span class="price">Valor + de <strong>12.5 MILLONES</strong></span> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premios/premio2.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">CANCÚN</h1>
                    <h3 class="subtitle-place">Residencial Mar</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premios/premio3.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">MÉRIDA</h1>
                    <h3 class="subtitle-place">Yucatán Country</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-3">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premios/premio4.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">PUEBLA</h1>
                    <h3 class="subtitle-place">Lomas de Angelópolis</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c1-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premios/premio5.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">QUERÉTARO</h1>
                    <h3 class="subtitle-place">El Campanario</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel1.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel1.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel1.select('c1-0')" [class.active]="carousel1.activeId === 'c1-0'">
              <img src="/assets/images/sorteo2026/premios/premio1.jpg" alt="Edo México">
              <div class="thumb-info"><span class="rank">1°</span> <span class="name">EDO. MÉX.</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-1')" [class.active]="carousel1.activeId === 'c1-1'">
              <img src="/assets/images/sorteo2026/premios/premio2.jpg" alt="Cancún">
              <div class="thumb-info"><span class="rank">2°</span> <span class="name">CANCÚN</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-2')" [class.active]="carousel1.activeId === 'c1-2'">
              <img src="/assets/images/sorteo2026/premios/premio3.jpg" alt="Mérida">
              <div class="thumb-info"><span class="rank">3°</span> <span class="name">MÉRIDA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-3')" [class.active]="carousel1.activeId === 'c1-3'">
              <img src="/assets/images/sorteo2026/premios/premio4.jpg" alt="Puebla">
              <div class="thumb-info"><span class="rank">4°</span> <span class="name">PUEBLA</span></div>
            </div>

            <div class="thumb-card" (click)="carousel1.select('c1-4')" [class.active]="carousel1.activeId === 'c1-4'">
              <img src="/assets/images/sorteo2026/premios/premio5.jpg" alt="Querétaro">
              <div class="thumb-info"><span class="rank">5°</span> <span class="name">QUERÉTARO</span></div>
            </div>
          </div>
        </div>

        <br><br>

        <div class="custom-slider-container">
          <ngb-carousel #carousel2 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c2-0">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio2-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">AUDI</h1>
                    <h3 class="subtitle-place">Q7 - Luxury Edition</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio2-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">MINI COOPER</h1>
                    <h3 class="subtitle-place">Serie 3</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c2-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio2-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">KIA</h1>
                    <h3 class="subtitle-place">k3</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel2.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel2.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">
            <div class="thumb-card" (click)="carousel2.select('c2-0')" [class.active]="carousel2.activeId === 'c2-0'">
              <img src="assets/images/sorteo2026/premio2-2025.jpg">
              <div class="thumb-info"><span class="rank">6°</span> <span class="name">AUDI</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-1')" [class.active]="carousel2.activeId === 'c2-1'">
              <img src="assets/images/sorteo2026/premio2-2025.jpg">
              <div class="thumb-info"><span class="rank">7°</span> <span class="name">MINI Cooper</span></div>
            </div>

            <div class="thumb-card" (click)="carousel2.select('c2-2')" [class.active]="carousel2.activeId === 'c2-2'">
              <img src="assets/images/sorteo2026/premio2-2025.jpg">
              <div class="thumb-info"><span class="rank">8°</span> <span class="name">kia k3</span></div>
            </div>
          </div>
        </div>


        <div class="custom-slider-container mt-5">
          <ngb-carousel #carousel3 [showNavigationIndicators]="false" [showNavigationArrows]="false" [interval]="0">

            <ng-template ngbSlide id="c3-0">
              <div class="main-slide"
                [style.backgroundImage]="'url(/assets/images/sorteo2026/premio3-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">MACBOOK AIR</h1>
                    <h3 class="subtitle-place">13 pulgadas - Chip M3</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-1">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio3-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">IPHONE 16</h1>
                    <h3 class="subtitle-place">Cámara Pro de 48MP</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-2">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio3-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">IPAD AIR</h1>
                    <h3 class="subtitle-place">Pantalla Liquid Retina</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-3">
              <div class="main-slide"
                [style.backgroundImage]="'url(/assets/images/sorteo2026/premio3-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">AIRPODS MAX</h1>
                    <h3 class="subtitle-place">Audio Espacial Personalizado</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template ngbSlide id="c3-4">
              <div class="main-slide" [style.backgroundImage]="'url(/assets/images/sorteo2026/premio3-2025.jpg)'">
                <div class="overlay-gradient"></div>
                <div class="overlay-content">
                  <div class="text-box">
                    <!-- <h1 class="title-city">APPLE WATCH SE</h1>
                    <h3 class="subtitle-place">Tu compañero de salud</h3> -->
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-carousel>

          <div class="slider-controls-wrapper">
            <button (click)="carousel3.prev()" class="btn-nav"><i class="fas fa-chevron-left"></i></button>
            <button (click)="carousel3.next()" class="btn-nav"><i class="fas fa-chevron-right"></i></button>
          </div>

          <div class="thumbnails-overlay">

            <div class="thumb-card" (click)="carousel3.select('c3-0')" [class.active]="carousel3.activeId === 'c3-0'">
              <img src="assets/images/sorteo2026/premio3-2025.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">13°-22°</span> <span class="name">MACBOOK AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-1')" [class.active]="carousel3.activeId === 'c3-1'">
              <img src="assets/images/sorteo2026/premio3-2025.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">23°-32°</span> <span class="name">IPHONE 17</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-2')" [class.active]="carousel3.activeId === 'c3-2'">
              <img src="assets/images/sorteo2026/premio3-2025.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">33°-42°</span> <span class="name">IPAD AIR</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-3')" [class.active]="carousel3.activeId === 'c3-3'">
              <img src="assets/images/sorteo2026/premio3-2025.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">43°-56°</span> <span class="name">AIRPODS MAX</span></div>
            </div>

            <div class="thumb-card" (click)="carousel3.select('c3-4')" [class.active]="carousel3.activeId === 'c3-4'">
              <img src="assets/images/sorteo2026/premio3-2025.jpg">
              <div class="thumb-info d-flex flex-column text-center"><span class="rank">57°-475°</span> <span class="name">WATCH SE</span></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>
